import { Component, OnInit } from '@angular/core';
import { PrimeIcons } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-registration-status',
  templateUrl: './registration-status.component.html',
  styleUrls: ['./registration-status.component.css']
})
export class RegistrationStatusComponent implements OnInit {
  isSubmitted: boolean = false;
  isReviewed: boolean = false;
  isApproved: boolean = false;
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
  ) { }
  events: any[];
  events1: any[];
  events2: any[];

  ngOnInit(): void {
    const param = this._route.snapshot.paramMap.get('message');
    if (param == 'Your UserProfile Submitted.!') {
      this.isReviewed = false;
      this.isSubmitted = true;
      this.events = [
        { status: 'Submitted', icon: PrimeIcons.CHECK_CIRCLE, color: '#82C836' },
        { status: 'In Review', icon: PrimeIcons.COG, color: '#fff' },
        { status: 'Approved', icon: PrimeIcons.THUMBS_UP, color: '#fff', message: 'Approved' }
      ];
      this.events1 = [
        { message: 'Your registration form has been successfully submitted' },
      ];
      this.events2 = [
        { message: 'Your registration form is under review by our MSP' },
      ];

    }
    if (param == 'Your UserProfile In Review.!') {
      this.isReviewed = true;
      this.isSubmitted = false;
      this.events = [
        { status: 'Submitted', icon: PrimeIcons.CHECK_CIRCLE, color: '#82C836' },
        { status: 'In Review', icon: PrimeIcons.COG, color: '#82C836' },
        { status: 'Approved', icon: PrimeIcons.THUMBS_UP, color: '#fff', message: 'Approved' }
      ];
      this.events1 = [
        { message: 'Your registration form has been successfully submitted' },
      ];
      this.events2 = [
        { message: 'Your registration form is under review by our MSP' },
      ];
    }

  }

}
